'use strict';

var formatInTimeZone = require('date-fns-tz/formatInTimeZone');
var constants = require('../constants.cjs');
var formatISODatePart = require('./formatISODatePart.cjs');
var formatISODateTimePart = require('./formatISODateTimePart.cjs');
var formatISOTimePart = require('./formatISOTimePart.cjs');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var formatInTimeZone__default = /*#__PURE__*/_interopDefault(formatInTimeZone);

const format = (params) => {
  const { presetName, date, locale, timeZone } = params;
  const isoDatePart = formatInTimeZone__default(date, timeZone, constants.ISO_DATE_PART_FORMAT);
  const isoTimePart = formatInTimeZone__default(date, timeZone, constants.ISO_TIME_PART_FORMAT);
  const isoDateTimePart = isoDatePart + "T" + isoTimePart;
  switch (presetName) {
    case "weekday":
    case "weekday_short":
    case "year":
    case "year_yearMin":
    case "year_month":
    case "year_month_yearMin":
    case "year_month_short":
    case "year_month_yearMin_short":
    case "month":
    case "month_day":
    case "month_day_short":
    case "month_day_weekday":
    case "month_day_weekday_short":
    case "day_of_month":
    case "date":
    case "date_short":
    case "date_yearMin_short":
    case "date_weekday":
    case "date_weekday_short":
      return formatISODatePart({
        presetName,
        isoDatePart,
        locale
      });
    case "time":
    case "time_short":
      return formatISOTimePart({
        presetName,
        isoTimePart,
        locale
      });
    case "datetime":
    case "datetime_short":
    case "datetime_seconds":
    case "datetime_seconds_short":
    case "datetime_weekday":
    case "datetime_weekday_short":
    case "month_day_time":
    case "month_day_time_short":
    case "month_day_time_weekday":
    case "month_day_time_weekday_short":
      return formatISODateTimePart({
        presetName,
        isoDateTimePart,
        locale
      });
  }
};

module.exports = format;
//# sourceMappingURL=format.cjs.map
